<template>
  <modern-bar-chart
    :title="title"
    :series="series"
    :categories="categories"
    :colors="chartColors"
    :height="350"
    :stacked="true"
    :horizontal="false"
    :display-mode="displayMode"
    percent-basis="category"
  />
</template>

<script>
import { companyComplaintsPerCompanyAndStatus } from "../../../../api/charts";
import { getStatusText, getStatusColor } from "../../../complaints/utils";
import ModernBarChart from "../ModernBarChart.vue";
import { displayModeMixin } from "../displayModeMixin";

export default {
  name: "ComplaintsPerStatus",
  mixins: [displayModeMixin],
  components: {
    ModernBarChart,
  },
  props: {
    company: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      title: "Qtd. Denúncias x Empresa x Situação",
      series: [],
      categories: [],
      chartColors: [],
    };
  },

  async created() {
    try {
      const response = await companyComplaintsPerCompanyAndStatus();
      const data = response.data;

      const labels = [];
      const colors = [];
      const datasets = {};

      for (const item of data) {
        const company = item.company;
        labels.push(company.fantasyName);

        for (let status in item.data) {
          if (!Object.prototype.hasOwnProperty.call(item.data, status))
            continue;
          if (!datasets[status]) {
            datasets[status] = {
              name: getStatusText(status),
              data: [],
            };
            colors.push(getStatusColor(status));
          }
          datasets[status].data.push(item.data[status]);
        }
      }

      this.categories = labels;
      this.chartColors = colors;

      const series = [];
      for (const status of Object.keys(datasets)) {
        const item = datasets[status];
        series.push(item);
      }

      this.series = series;
    } catch (error) {
      console.error("Erro ao carregar dados do gráfico:", error);
    }
  },
};
</script>
